import actions from './actions';
import initRequests from './requests';

const yoproducts = {
  actions,
  initRequests,
};

export default yoproducts;
yoproducts;
